<template>
  <div class="mark-wrap">
    <slot></slot>
  </div>
</template>

<script>
import MarkJs from './../js/mark.es6.js'
import utils from './../js/utils.js'

export default {
  name: 'Mark',
  props: {
    hints: String,
    selector: String,
    strict: Boolean
  },
  data () {
    return {
      timer: null,
      options: {}
    }
  },
  watch: {
    hints () {
      this.renderMark()
    },
    selector () {
      this.initOptions()
      this.renderMark()
    }
  },
  created () {
    this.initOptions()
    this.renderMark()
  },
  methods: {
    initOptions () {
      if (this.selector) {
        this.options.filter = (node, term, totalCounter, counter) => {
          return node.parentNode.closest(this.selector)
        }
      } else if(this.options.filter) {
        delete this.options.filter
      }
      if (this.strict) {
        this.options.accuracy = 'exactly'
      }
    },
    renderMark () {
      if (!this._renderMark) {
        this._renderMark = utils.debounce(() => {
          if (!this.hints) {
            if (this.$mark) {
              this.$mark.unmark(this.options)
            }
            return
          }
          if (!this.$mark) {
            this.$mark = new MarkJs(this.$el)
          } else {
            this.$mark.unmark(this.options)
          }
          this.$mark.mark(this.hints, this.options)
        }, 500)
      }
      this._renderMark()
    }
  }
}
</script>